import IsolatedPurchaseOrderControl from '@/ui/components/isolatedPurchaseOrderControl/IsolatedPurchaseOrderControl';
import { getHydratedPurchaseOrder } from '@payaca/store/materialsList/materialsListActions';
import {
  HydratedPurchaseOrder,
  PurchaseOrder,
} from '@payaca/types/materialsListTypes';
import { FC, useCallback, useEffect, useState, type JSX } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import AuthenticatedPageWrapper from '../pageWrappers/authenticatedPageWrapper/AuthenticatedPageWrapper';

type Props = {
  purchaseOrderId: PurchaseOrder['id'];
};

const EditIsolatedPurchaseOrderPage: FC<Props> = ({
  purchaseOrderId,
}: Props): JSX.Element | null => {
  const dispatch = useDispatch();
  const [purchaseOrder, setPurchaseOrder] = useState<HydratedPurchaseOrder>();
  const history = useHistory();

  const getPurchaseOrder = useCallback(() => {
    dispatch(
      getHydratedPurchaseOrder.request({
        purchaseOrderId,
        callback: (purchaseOrder) => {
          setPurchaseOrder(purchaseOrder);
        },
      })
    );
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useCallback has missing dependencies: 'purchaseOrderId', and 'dispatch'
  }, []);

  useEffect(() => {
    getPurchaseOrder();
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'getPurchaseOrder'
  }, []);

  useEffect(() => {
    if (
      !!purchaseOrder &&
      (!purchaseOrder.isIsolated ||
        purchaseOrder.sentAt ||
        purchaseOrder.voidedAt ||
        purchaseOrder.confirmedAt)
    ) {
      history.push(`/purchaseorders/${purchaseOrder?.id}`);
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has missing dependencies: 'purchaseOrder.id', 'history', 'purchaseOrder.sentAt', 'purchaseOrder.confirmedAt', 'purchaseOrder.voidedAt', and 'purchaseOrder'
  }, [purchaseOrder?.isIsolated]);

  return (
    <AuthenticatedPageWrapper
      breadcrumbItems={[
        {
          label: 'Back',
          to: `/suppliers/${purchaseOrder?.supplierId}?tab=purchase-orders`,
        },
        { label: 'Purchase Order' },
      ]}
    >
      <div className="typography:prose">
        <h1 className="px-8 py-4">{`Purchase Order${
          purchaseOrder ? ` for ${purchaseOrder?.supplier.name}` : ''
        }`}</h1>
      </div>
      {purchaseOrder && (
        <div className="m-8">
          <IsolatedPurchaseOrderControl
            purchaseOrder={purchaseOrder}
            onPreviewPurchaseOrderClick={() =>
              history.push(`/purchaseorders/${purchaseOrderId}`)
            }
          />
        </div>
      )}
    </AuthenticatedPageWrapper>
  );
};
export default EditIsolatedPurchaseOrderPage;
